export default "__VITE_ASSET__cF5AZjzz__"